import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sidebarOpen: true,
    activeTab: 'dashboard',
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.sidebarOpen = !state.sidebarOpen;
        },
        setSidebarOpen: (state, action) => {
            state.sidebarOpen = action.payload;
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
    },
});

export const { toggleSidebar, setSidebarOpen, setActiveTab } = uiSlice.actions;
export default uiSlice.reducer;
